import { useState, type ReactNode } from 'react';
import { Button, Dialog } from '@zt/ui';
import { useT } from '../lib/i18n';

/** Geri alınamaz veya etkisi büyük işlemler için onay penceresi. */
export function ConfirmButton({
  children,
  message,
  onConfirm,
  variant = 'danger',
  size = 'sm',
  disabled,
}: {
  children: ReactNode;
  message: string;
  onConfirm: () => Promise<unknown> | void;
  variant?: 'danger' | 'secondary' | 'primary' | 'ghost';
  size?: 'sm' | 'md';
  disabled?: boolean;
}) {
  const t = useT();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  return (
    <>
      <Button variant={variant} size={size} onClick={() => setOpen(true)} disabled={disabled}>
        {children}
      </Button>
      <Dialog
        open={open}
        onOpenChange={setOpen}
        title={t('admin.confirm.title')}
        closeLabel={t('common.close')}
        footer={
          <>
            <Button onClick={() => setOpen(false)}>{t('common.cancel')}</Button>
            <Button
              variant={variant === 'danger' ? 'danger' : 'primary'}
              loading={busy}
              onClick={async () => {
                setBusy(true);
                try {
                  await onConfirm();
                  setOpen(false);
                } finally {
                  setBusy(false);
                }
              }}
            >
              {t('admin.confirm.yes')}
            </Button>
          </>
        }
      >
        <p className="text-ink-2">{message}</p>
      </Dialog>
    </>
  );
}
